import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { FlyerBanner } from "@/components/home/FlyerBanner";
import { InstallBanner } from "@/components/home/InstallBanner";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { GalleryPreview } from "@/components/home/GalleryPreview";
import { Testimonials } from "@/components/home/Testimonials";
import { MembershipBanner } from "@/components/home/MembershipBanner";
import { CtaBanner } from "@/components/home/CtaBanner";

const BASE = process.env.REACT_APP_BACKEND_URL;
const SAMPLE_PREVIEW = [
  { src: "https://images.unsplash.com/photo-1549109926-58f039549485?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxzZWN1cml0eSUyMGNhbWVyYSUyMGNjdHYlMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzg4NTQwNjAyfDA&ixlib=rb-4.1.0&q=85", tag: "CCTV", title: "Storefront 8-camera IP system" },
  { src: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHxffHxzZXJ2ZXIlMjByYWNrJTIwbmV0d29ya2luZyUyMGNhYmxlc3xlbnwwfHx8fDE3ODg1NDA2MDJ8MA&ixlib=rb-4.1.0&q=85", tag: "Networking", title: "10G rack + patch panel rebuild" },
  { src: "https://images.unsplash.com/photo-1589935447067-5531094415d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHxffHxzZWN1cml0eSUyMGNhbWVyYSUyMGNjdHYlMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzg4NTQwNjAyfDA&ixlib=rb-4.1.0&q=85", tag: "Security", title: "Multi-unit residential coverage" },
];

export default function Home() {
  const [preview, setPreview] = useState(SAMPLE_PREVIEW);
  const [hero, setHero] = useState(null);
  const [flyer, setFlyer] = useState(null);
  const [flyerDownload, setFlyerDownload] = useState(null);
  useEffect(() => {
    api.get("/branding").then((r) => {
      if (r.data.images?.hero) setHero(`${BASE}${r.data.images.hero}`);
      if (r.data.flyer_url) setFlyer(`${BASE}${r.data.flyer_url}`);
      if (r.data.flyer_download_url) setFlyerDownload(`${BASE}${r.data.flyer_download_url}`);
    }).catch(() => {});
    api.get("/gallery").then((r) => {
      if (r.data.length) setPreview(r.data.slice(0, 3).map((g) => ({ id: g.id, src: `${BASE}${g.img}`, before: g.before_img ? `${BASE}${g.before_img}` : null, tag: g.category, title: g.title, subtitle: g.subtitle, installed: g.installed !== false })));
    }).catch(() => {});
  }, []);
  return (
    <div>
      <FlyerBanner flyer={flyer} download={flyerDownload || flyer} />
      <Hero image={hero} />
      <ServicesGrid />
      <InstallBanner />
      <MembershipBanner />
      <GalleryPreview items={preview} />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
